// Solen Product Extras: viewer count, delivery date, sticky cart logic

(function () {
  'use strict';

  // ==================== IMAGE HEIGHT ENFORCER (DISABLED) ====================
  // Image height kuralları geri alindi. Habitat default kalsin.
  if (false) {
  function enforceImageHeights() {
    const isMobile = window.innerWidth <= 768;
    const imgVh = isMobile ? 0.42 : 0.55;
    const containerVh = isMobile ? 0.48 : 0.6;
    const imgMax = Math.round(window.innerHeight * imgVh);
    const containerMax = Math.round(window.innerHeight * containerVh);

    document.querySelectorAll('.product-image-container img, product-slider img').forEach(img => {
      img.style.setProperty('max-height', imgMax + 'px', 'important');
      img.style.setProperty('max-width', '100%', 'important');
      img.style.setProperty('width', 'auto', 'important');
      img.style.setProperty('height', 'auto', 'important');
      img.style.setProperty('object-fit', 'contain', 'important');
      img.style.setProperty('display', 'block', 'important');
      img.style.setProperty('margin', '0 auto', 'important');
    });

    document.querySelectorAll(
      '.product-image-container .flickity-viewport, ' +
      '.product-image-container .product-images, ' +
      '.product-image-container .product-images__slide, ' +
      '.product-image-container .product-single__media, ' +
      '.product-image-container .product-single__media-image, ' +
      'product-slider .flickity-viewport'
    ).forEach(el => {
      el.style.setProperty('max-height', containerMax + 'px', 'important');
      el.style.setProperty('overflow', 'hidden', 'important');
    });
  }

  // İlk run + tum hazirlik adimlarinda
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforceImageHeights);
  } else {
    enforceImageHeights();
  }
  window.addEventListener('load', enforceImageHeights);
  window.addEventListener('resize', enforceImageHeights);

  // 5 saniye boyunca her 200ms dene (Flickity init asenkron)
  let attempts = 0;
  const initInterval = setInterval(() => {
    enforceImageHeights();
    if (++attempts > 25) clearInterval(initInterval);
  }, 200);

  // MutationObserver: DOM degisirse tekrar uygula
  const setupObserver = () => {
    const target = document.querySelector('.product-image-container') || document.querySelector('product-slider');
    if (!target) return false;
    const obs = new MutationObserver(() => {
      window.requestAnimationFrame(enforceImageHeights);
    });
    obs.observe(target, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
    return true;
  };
  if (!setupObserver()) {
    setTimeout(setupObserver, 500);
    setTimeout(setupObserver, 1500);
  }
  } // end if(false)


  // ========== Viewer Count (simulated, deterministic per product) ==========
  // Hash product ID to a baseline (8-24), then small random fluctuations.
  function hashId(str) {
    let h = 0;
    for (let i = 0; i < str.length; i++) h = ((h << 5) - h + str.charCodeAt(i)) | 0;
    return Math.abs(h);
  }

  function seededHash(seed) {
    let h = 0;
    for (let i = 0; i < seed.length; i++) h = ((h << 5) - h + seed.charCodeAt(i)) | 0;
    return Math.abs(h);
  }
  const todayKey = new Date().toDateString();
  const hourKey = todayKey + '_h' + new Date().getHours();

  function setAll(parent, sel, value) {
    parent.querySelectorAll(sel).forEach(n => n.textContent = value);
  }

  document.querySelectorAll('[data-solen-viewers]').forEach(el => {
    const productId = el.dataset.productId || 'x';
    if (!el.querySelector('[data-viewer-count]')) return;
    const baseline = 8 + (hashId(productId) % 17); // 8-24
    let current = baseline;
    setAll(el, '[data-viewer-count]', current);
    setInterval(() => {
      const delta = Math.floor(Math.random() * 5) - 2; // -2..+2
      current = Math.max(5, Math.min(35, current + delta));
      setAll(el, '[data-viewer-count]', current);
    }, 6000 + Math.random() * 4000);
  });

  document.querySelectorAll('[data-solen-sales]').forEach(el => {
    const id = el.dataset.productId || 'x';
    const count = 14 + (seededHash(id + '_' + todayKey + '_sales') % 47); // 14-60
    setAll(el, '[data-sales-count]', count);
  });

  document.querySelectorAll('[data-solen-cart]').forEach(el => {
    const id = el.dataset.productId || 'x';
    const count = 3 + (seededHash(id + '_' + hourKey + '_cart') % 11); // 3-13
    setAll(el, '[data-cart-count]', count);
  });

  // ========== Recent purchase toast ==========
  function makeToast(html) {
    const toast = document.createElement('div');
    toast.className = 'solen-toast';
    toast.innerHTML = html + '<button class="solen-toast__close" aria-label="Kapat">×</button>';
    document.body.appendChild(toast);
    requestAnimationFrame(() => toast.classList.add('is-visible'));
    const close = () => { toast.classList.remove('is-visible'); setTimeout(() => toast.remove(), 400); };
    toast.querySelector('.solen-toast__close').onclick = close;
    setTimeout(close, 7500);
  }
  function getProductId() {
    const el = document.querySelector('[data-solen-sales]');
    return el?.dataset.productId || 'x';
  }
  const cities = ['İstanbul', 'Ankara', 'İzmir', 'Bursa', 'Antalya', 'Konya', 'Adana', 'Gaziantep', 'Kayseri', 'Eskişehir', 'Samsun', 'Mersin', 'Trabzon', 'Diyarbakır'];
  const names = ['Ahmet K.', 'Mehmet Y.', 'Fatma Ö.', 'Elif D.', 'Selin T.', 'Burak A.', 'Hale Ş.', 'Zeynep G.', 'Cem K.', 'Nilgün B.', 'Rıza E.', 'Derya Ç.'];

  let toastCounter = 0;
  function fireToast() {
    if (!document.querySelector('[data-solen-sales]')) return;
    toastCounter++;
    const isPurchase = toastCounter % 2 === 1;
    const seed = seededHash(getProductId() + '_' + hourKey + '_t' + toastCounter + '_' + Date.now());
    const name = names[seed % names.length];
    const city = cities[(seed >> 4) % cities.length];

    if (isPurchase) {
      const min = 2 + (seed % 28);
      makeToast(`
        <div class="solen-toast__icon solen-toast__icon--green">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
        </div>
        <div class="solen-toast__body">
          <strong>${name}</strong> · ${city}<br>
          <span>${min} dakika önce satın aldı ✓</span>
        </div>
      `);
    } else {
      makeToast(`
        <div class="solen-toast__icon solen-toast__icon--orange">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6"/></svg>
        </div>
        <div class="solen-toast__body">
          <strong>${name}</strong> · ${city}<br>
          <span>az önce sepete ekledi</span>
        </div>
      `);
    }
  }

  // Ilk toast 8 sn sonra, sonra her 15-20 dk arasi random
  setTimeout(() => {
    fireToast();
    function scheduleNext() {
      const ms = (15 + Math.random() * 5) * 60 * 1000; // 15-20 dk
      setTimeout(() => { fireToast(); scheduleNext(); }, ms);
    }
    scheduleNext();
  }, 8000);

  // ========== Delivery Date (real: today + 2-4 business days) ==========
  function addBusinessDays(date, days) {
    const d = new Date(date);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }
  const months = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
  const days = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];

  document.querySelectorAll('[data-solen-delivery] [data-delivery-date]').forEach(el => {
    const today = new Date();
    const arrival = addBusinessDays(today, 3); // 3 iş günü
    el.textContent = `${arrival.getDate()} ${months[arrival.getMonth()]} ${days[arrival.getDay()]}`;
  });

  // (Sticky cart kaldirildi)
})();
